import { useEffect, useState } from "react";

export default function MissionComponent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("mission");
      if (!el) return;

      const rect = el.getBoundingClientRect();

      if (rect.top < window.innerHeight - 100) {
        setVisible(true);
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section
      id="mission"
      className="bg-[#F7F4EE] py-1 sm:py-20 lg:py-20 px-6 sm:px-6 md:px-10 lg:px-32 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto">

        {/* TOP SECTION */}
        <div
          className={`flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 sm:gap-8 mb-10 sm:mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div>
            <p className="text-xs lg:text-md tracking-[0.35em] sm:tracking-[0.45em] text-green-500 mb-3 sm:mb-4">
              VISION AND MISSION
            </p>
          </div>

          <div className="w-16 sm:w-20 h-[2px] bg-green-400 rounded-full" />
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 sm:gap-6 lg:gap-8">

          {/* VISION */}
          <div
            className={`group bg-white border border-green-100 rounded-[20px] sm:rounded-[28px] p-6 sm:p-8 md:p-10 hover:-translate-y-1 hover:shadow-2xl transition-all duration-500 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="flex items-center justify-between mb-6 sm:mb-8">
              <p className="text-xs tracking-[0.3em] sm:tracking-[0.35em] text-green-500 font-medium">
                VISION
              </p>

              <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full border border-green-200 flex items-center justify-center">
                <div className="w-1.5 sm:w-2 h-1.5 sm:h-2 rounded-full bg-green-400" />
              </div>
            </div>

            <p className="md:text-lg leading-[1.7] sm:leading-[1.9] text-[#4B4B4B] max-w-full sm:max-w-md">
              A climate-resilient future where women, youth, and farming
              communities thrive through sustainable livelihoods,
              environmental stewardship, and inclusive development.
            </p>
          </div>

          {/* MISSION */}
          <div
            className={`group bg-[#0F172A] rounded-[20px] sm:rounded-[28px] p-6 sm:p-8 md:p-10 hover:-translate-y-1 hover:shadow-2xl transition-all duration-500 delay-100 border border-green-400/10 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="flex items-center justify-between mb-6 sm:mb-8">
              <p className="text-xs tracking-[0.3em] sm:tracking-[0.35em] text-green-400 font-medium">
                MISSION
              </p>

              <div className="w-8 sm:w-10 h-8 sm:h-10 rounded-full border border-green-400/20 flex items-center justify-center">
                <div className="w-1.5 sm:w-2 h-1.5 sm:h-2 rounded-full bg-green-400" />
              </div>
            </div>

            <p className="md:text-lg leading-[1.7] sm:leading-[1.9] text-[#D6D6D6] max-w-full lg:max-w-lg">
              To advance climate-smart agriculture, environmental
              sustainability, and community empowerment through practical,
              measurable, and locally driven solutions that improve
              livelihoods and strengthen resilience.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}